// extracted by mini-css-extract-plugin
export var button = "_aq-0";
export var icon = "_aq-1";